import { logger } from '../../../util/logger';
import { EMPTY, from } from 'rxjs';
import { catchError, distinctUntilKeyChanged, map, mergeMap } from 'rxjs/operators';
import { clampIfStreemshotRequestWasFulfilled } from '../../../util/rx/clamp_if_streemshot_request_was_fulfilled';
export class StreemshotEngine {
    constructor() {
        this.convertCanvasToBlob = (canvas) => {
            return new Promise((res, rej) => canvas.toBlob(blob => blob
                ? res(blob)
                : // eslint-disable-next-line prefer-promise-reject-errors
                    rej('Failed to create blob from canvas because blob is null'), 'image/jpeg', 0.7));
        };
    }
    /**
     * `fulfillStreemshotRequestsForWeb` returns an observable that will return a blob of image data and its streemshot request
     * @param opts FulfillStreemshotOpts
     */
    fulfillStreemshotRequestsForWeb(opts) {
        return opts.latestStreemshotRequest.pipe(distinctUntilKeyChanged('id'), clampIfStreemshotRequestWasFulfilled(opts.streemshots), mergeMap(latestRequest => this.mergeBlobAndLatestRequest(opts.canvas, latestRequest)));
    }
    mergeBlobAndLatestRequest(canvas, request) {
        return from(this.convertCanvasToBlob(canvas)).pipe(map((blob) => [request, blob]), catchError(err => {
            logger.error('Cannot take streemshot on web: ', err);
            return EMPTY;
        }));
    }
}
//# sourceMappingURL=streemshot_engine.js.map